import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { useNavigate } from "react-router-dom";

// Fired before the back button navigates. Something open on top of the page
// (e.g. the navigation drawer) can call preventDefault() to close itself
// instead.
export const BACK_EVENT = "zenith:back";

export const useAndroidBackButton = () => {
    const navigate = useNavigate();

    useEffect(() => {
        let listener;

        const addListener = async () => {
            listener = await CapacitorApp.addListener("backButton", ({ canGoBack }) => {
                const back = new Event(BACK_EVENT, { cancelable: true });
                if (!window.dispatchEvent(back)) return; // handled (e.g. drawer closed)
                if (canGoBack) {
                    navigate(-1);
                } else {
                    CapacitorApp.exitApp();
                }
            });
        };

        addListener();

        return () => {
            if (listener) {
                listener.remove();
            }
        };
    }, [navigate]);

    return null;
};

